<template>
  <div
    class="card plan-card"
    :class="{ 'is-selected': isSelected, 'is-active': isActive }"
    @click="$emit('click', plan)"
  >
    <div class="card-content">
      <div class="media">
        <div class="media-content has-text-centered">
          <p class="title is-4">{{ plan.name }}</p>
          <p class="subtitle is-6">${{ plan.base_cost }}/mo</p>
        </div>
      </div>

      <div class="content">
        <div class="mt-2 has-text-centered">
          <small v-if="!plan.is_enabled" class="has-text-danger">This plan is grandfathered</small>
        </div>

        <ul>
          <li>
            {{ plan.base_inquiries }} Inquiries
            <small class="has-text-grey">(${{ plan.addl_cost }} per extra)</small>
          </li>
          <li>Unlimited Users</li>
          <li>Unlimited Providers/Facilities</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SubscriptionOption',
  props: {
    plan: {
      required: true,
      type: Object,
    },
    isActive: {
      required: false,
      type: Boolean,
      default: false,
    },
    isSelected: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.plan-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.plan-card:hover {
  border-color: #3273dc;
  transform: translateY(-2px);
}

.plan-card.is-selected {
  border-color: #3273dc;
  background-color: #f0f6ff;
}

.plan-card.is-active {
  border-color: #23d160;
  background-color: #f0fff4;
}
</style>
